/* OFFGRID theme — header, catalog filtering/sorting, product form. No dependencies. */
(function () {
  'use strict';
  var root = document.documentElement;
  root.classList.remove('no-js');
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Header: hide on scroll down, show on scroll up (like Nike) ---------- */
  var header = $('.site-header'), lastY = window.scrollY, ticking = false;
  function onScroll() {
    ticking = false;
    var y = window.scrollY, hide = y > 160 && y > lastY;
    if (Math.abs(y - lastY) > 4) {
      header && header.classList.toggle('is-hidden', hide);
      root.classList.toggle('header-hidden', hide);
      lastY = y;
    }
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });

  /* ---------- Mobile menu ---------- */
  function setMenu(open) {
    root.classList.toggle('menu-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
    $$('[data-menu-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', open); });
    if (open) { var f = $('.drawer-menu__panel a, .drawer-menu__panel button'); f && f.focus(); }
  }
  $$('[data-menu-toggle]').forEach(function (b) { b.addEventListener('click', function () { setMenu(!root.classList.contains('menu-open')); }); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { setMenu(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setMenu(false); setFilters(false); closeSort(); } });

  /* ---------- Catalog ---------- */
  var catalog = $('[data-catalog]');
  var mobile = window.matchMedia('(max-width: 960px)');
  function setFilters(open) {
    if (!catalog) return;
    catalog.classList.toggle('filters-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  function closeSort() { var m = $('[data-sort-menu]'); if (m) { m.hidden = true; $('[data-sort-toggle]').setAttribute('aria-expanded', false); } }

  if (catalog) {
    var cards = $$('[data-card]', catalog);
    var groups = $$('[data-group]', catalog);
    var countEls = $$('[data-count]');
    var empty = $('[data-empty]', catalog);
    var state = { cat: '', sort: 'featured' };

    // Hide / show filters (desktop) or open sheet (mobile)
    var toggle = $('[data-filter-toggle]', catalog);
    toggle && toggle.addEventListener('click', function () {
      if (mobile.matches) { setFilters(true); return; }
      var hidden = catalog.classList.toggle('filters-hidden');
      toggle.setAttribute('aria-pressed', hidden);
      $('[data-filter-label]', toggle).textContent = hidden ? toggle.dataset.show : toggle.dataset.hide;
      try { localStorage.setItem('og-filters-hidden', hidden ? '1' : ''); } catch (e) {}
    });
    try { if (localStorage.getItem('og-filters-hidden') && !mobile.matches) toggle && toggle.click(); } catch (e) {}
    $$('[data-filter-close]', catalog).forEach(function (b) { b.addEventListener('click', function () { setFilters(false); }); });

    // Sort menu
    var sortToggle = $('[data-sort-toggle]', catalog), sortMenu = $('[data-sort-menu]', catalog);
    sortToggle && sortToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      sortMenu.hidden = !sortMenu.hidden;
      sortToggle.setAttribute('aria-expanded', !sortMenu.hidden);
    });
    document.addEventListener('click', function (e) { if (sortMenu && !sortMenu.contains(e.target)) closeSort(); });
    $$('[data-sort]', catalog).forEach(function (b) {
      b.addEventListener('click', function () {
        state.sort = b.dataset.sort;
        $$('[data-sort]', catalog).forEach(function (x) { x.setAttribute('aria-checked', x === b); });
        $('[data-sort-label]', catalog).textContent = b.dataset.short || b.textContent;
        closeSort(); apply();
      });
    });

    // Category buttons (Shirts / Sweaters / Pants ...)
    function setCat(cat, scroll) {
      state.cat = cat || '';
      $$('[data-cat-filter]', catalog).forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.catFilter === state.cat); });
      apply();
      if (scroll) { var top = catalog.getBoundingClientRect().top + window.scrollY - 70; if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' }); }
    }
    $$('[data-cat-filter]', catalog).forEach(function (b) {
      b.addEventListener('click', function () {
        var cat = (b.dataset.catFilter === state.cat) ? '' : b.dataset.catFilter;
        setCat(cat, true);
        if (history.replaceState) history.replaceState(null, '', cat ? '#' + b.dataset.catHandle : location.pathname + location.search);
      });
    });
    // Menu links like /#cat-shirts open one category
    function fromHash() {
      var h = location.hash.replace('#', '');
      var b = h && $('[data-cat-handle="' + h + '"]', catalog);
      if (b) setCat(b.dataset.catFilter, false);
    }
    window.addEventListener('hashchange', fromHash);

    catalog.addEventListener('change', function (e) { if (e.target.matches('[data-facet]')) apply(); });
    $$('[data-clear]', catalog).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-facet]', catalog).forEach(function (i) { i.checked = false; });
        setCat('', false);
      });
    });

    function checked(name) { return $$('[data-facet="' + name + '"]:checked', catalog).map(function (i) { return i.value; }); }
    function has(list, csv) { var vals = (csv || '').split('|'); return list.some(function (v) { return vals.indexOf(v) > -1; }); }

    function apply() {
      var sizes = checked('size'), colors = checked('color'), prices = checked('price'), avail = checked('available');
      var shown = 0;
      cards.forEach(function (c) {
        var p = +c.dataset.price / 100;
        var ok = (!state.cat || c.dataset.cat === state.cat)
          && (!sizes.length || has(sizes, c.dataset.sizes))
          && (!colors.length || has(colors, c.dataset.colors))
          && (!avail.length || c.dataset.available === 'true')
          && (!prices.length || prices.some(function (r) { var a = r.split('-'); return p >= +a[0] && (a[1] === '' || p < +a[1]); }));
        c.hidden = !ok; if (ok) shown++;
      });
      var cmp = function (a, b) {
        switch (state.sort) {
          case 'newest': return (+b.dataset.date) - (+a.dataset.date);
          case 'price-desc': return (+b.dataset.price) - (+a.dataset.price);
          case 'price-asc': return (+a.dataset.price) - (+b.dataset.price);
          default: return (+a.dataset.index) - (+b.dataset.index);
        }
      };
      groups.forEach(function (g) {
        var grid = $('[data-grid]', g), gc = $$('[data-card]', grid);
        gc.sort(cmp).forEach(function (c) { grid.appendChild(c); });
        g.hidden = !gc.some(function (c) { return !c.hidden; });
      });
      if (empty) empty.hidden = shown > 0 || cards.length === 0;
      countEls.forEach(function (el) { el.textContent = shown; });
    }
    fromHash();
  }

  /* ---------- Card hover: cycle through in-stock colours ---------- */
  var canHover = window.matchMedia('(hover: hover)').matches;
  $$('[data-card]').forEach(function (card) {
    var data = $('[data-cycle]', card);
    var img = $('.card__media img', card);
    if (!data || !img) return;
    var list; try { list = JSON.parse(data.textContent); } catch (e) { return; }
    if (list.length < 2) return;
    var orig = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') };
    var dots = $$('.card__swatches i', card);
    var i = 0, timer = null, loaded = false;
    function preload() { if (loaded) return; loaded = true; list.forEach(function (x) { var im = new Image(); im.src = x.s; }); }
    function mark(color) { dots.forEach(function (d) { d.classList.toggle('is-active', d.dataset.swatch === color); }); }
    function show(k) {
      i = (k + list.length) % list.length;
      img.removeAttribute('srcset');
      img.src = list[i].s;
      mark(list[i].c);
    }
    function reset() {
      clearInterval(timer); timer = null;
      img.src = orig.src; if (orig.srcset) img.setAttribute('srcset', orig.srcset);
      mark(null);
    }
    if (canHover) {
      card.addEventListener('mouseenter', function () {
        preload();
        var path = function (u) { return (u || '').split('?')[0]; };
        var start = list.findIndex(function (x) { return path(x.s) === path(orig.src); });
        show(start + 1);
        clearInterval(timer);
        timer = setInterval(function () { show(i + 1); }, 1100);
      });
      card.addEventListener('mouseleave', reset);
      // Hovering a colour dot pins that colour
      dots.forEach(function (d) {
        d.addEventListener('mouseenter', function () {
          var k = list.findIndex(function (x) { return x.c === d.dataset.swatch; });
          if (k > -1) { clearInterval(timer); timer = null; show(k); }
        });
      });
    }
  });

  /* ---------- Colour swatches: map apparel colour names to a dot colour ---------- */
  var COLOURS = { 'cream': '#ece2cc', 'off white': '#f1ede4', 'off-white': '#f1ede4', 'bone': '#e6dfd0', 'natural': '#e9dfc9', 'sand': '#d8c7a5', 'tan': '#c8a97e',
    'khaki': '#b5a47a', 'stone': '#b9b2a4', 'heather grey': '#b7b7b4', 'heather gray': '#b7b7b4', 'ash': '#c9c8c4', 'grey': '#8d8d8a', 'gray': '#8d8d8a',
    'charcoal': '#3b3b3b', 'washed black': '#2e2d2b', 'vintage black': '#2e2d2b', 'black': '#141414', 'white': '#ffffff', 'navy': '#1f2a44',
    'indigo': '#2f3e66', 'washed indigo': '#3a4a70', 'washed navy': '#34415e', 'blue': '#2f5aa8', 'olive': '#66673d', 'forest': '#2f4a35', 'green': '#3c6b45',
    'brown': '#6b4a32', 'mocha': '#7a5c48', 'chocolate': '#4a3022', 'red': '#b22d24', 'burgundy': '#5e1f27', 'maroon': '#5e1f27', 'orange': '#d46a2a', 'pink': '#e4b4bd', 'purple': '#5b4677',
    // OFFGRID colour names (matched to the washed garments in the mockups)
    'sky blue': '#8db6dc', 'light blue': '#a9c6e2', 'royal blue': '#3d5fc4', 'jeans blue': '#4b6b9b', 'denim': '#4b6b9b', 'navy blue': '#25304b',
    'light apricot': '#ead4b6', 'apricot': '#e8c39e', 'light gray': '#c8c8c5', 'light grey': '#c8c8c5', 'dark gray': '#474744', 'dark grey': '#474744',
    'flower gray': '#9b9b97', 'white gray': '#dcdbd6', 'wine red': '#76222f', 'wine': '#76222f', 'coffee': '#5a4130', 'washed brown': '#6e5040' };
  $$('[data-swatch]').forEach(function (el) {
    var n = (el.dataset.swatch || '').trim().toLowerCase();
    var c = COLOURS[n];
    // Longest known colour word inside the name wins ("Washed Sky Blue" -> sky blue, not blue)
    if (!c) { var best = ''; Object.keys(COLOURS).forEach(function (k) { if (n.indexOf(k) > -1 && k.length > best.length) best = k; }); if (best) c = COLOURS[best]; }
    if (!c && window.CSS && CSS.supports('color', n.replace(/\s+/g, ''))) c = n.replace(/\s+/g, '');
    el.style.setProperty('--c', c || '#cfcbc2');
  });

  /* ---------- Product gallery: one photo at a time; arrows/thumbs/swipe only see the selected colour ---------- */
  var gallery = $('[data-gallery]');
  var filterGallery = function () {};
  if (gallery) {
    var tiles = $$('.tile', gallery);
    var thumbsWrap = $('[data-thumbs]');
    var prevBtn = $('[data-gallery-prev]'), nextBtn = $('[data-gallery-next]');
    var tagged = tiles.some(function (t) { return t.dataset.mediaColor; });
    var current = 0;

    // Build one thumbnail per photo
    var thumbs = tiles.map(function (t, k) {
      var img = $('img', t);
      if (!img || !thumbsWrap) return null;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'thumb';
      b.setAttribute('aria-label', (thumbsWrap.dataset.label || 'Show photo') + ' ' + (k + 1));
      var ti = document.createElement('img');
      ti.src = img.currentSrc || img.src; ti.alt = ''; ti.loading = 'lazy';
      b.appendChild(ti);
      b.addEventListener('click', function () { go(k); });
      b.addEventListener('mouseenter', function () { go(k); });
      thumbsWrap.appendChild(b);
      return b;
    });

    function visible() { return tiles.filter(function (t) { return !t.hidden; }); }
    function go(k) {
      if (!tiles[k] || tiles[k].hidden) return;
      current = k;
      tiles.forEach(function (t, j) { t.classList.toggle('is-active', j === k); });
      thumbs.forEach(function (b, j) { if (b) b.setAttribute('aria-current', j === k); });
    }
    function step(dir) {
      var vis = visible(); if (vis.length < 2) return;
      var pos = vis.indexOf(tiles[current]);
      var next = vis[(pos + dir + vis.length) % vis.length];
      go(tiles.indexOf(next));
    }
    function refresh() {
      thumbs.forEach(function (b, j) { if (b) b.hidden = tiles[j].hidden; });
      var vis = visible();
      var many = vis.length > 1;
      if (prevBtn) prevBtn.hidden = !many;
      if (nextBtn) nextBtn.hidden = !many;
      if (thumbsWrap) thumbsWrap.hidden = !many;
      go(tiles.indexOf(vis[0]));
    }
    filterGallery = function (color) {
      if (tagged && color != null) {
        // Strict: if the chosen colour has its own photos, show only those (arrows, thumbs and swipe follow).
        // Otherwise fall back to photos with no colour, then to everything, so the gallery is never empty.
        var match = tiles.filter(function (t) { return t.dataset.mediaColor === color; });
        var untagged = tiles.filter(function (t) { return !t.dataset.mediaColor; });
        var keep = match.length ? match : (untagged.length ? untagged : tiles);
        tiles.forEach(function (t) { t.hidden = keep.indexOf(t) === -1; });
      }
      refresh();
    };
    prevBtn && prevBtn.addEventListener('click', function () { step(-1); });
    nextBtn && nextBtn.addEventListener('click', function () { step(1); });

    // Swipe on phones
    var stage = gallery.parentElement, x0 = null, y0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
      x0 = null;
    }, { passive: true });
    // Arrow keys when the gallery has focus
    stage.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') step(-1); if (e.key === 'ArrowRight') step(1); });

    var fs = $('[data-color-option]'), c0 = fs && $('input:checked', fs);
    filterGallery(c0 ? c0.value : null);
  }

  /* ---------- Product: variant selection ---------- */
  $$('[data-product-form]').forEach(function (form) {
    var json = $('script[type="application/json"]', form);
    if (!json) return;
    var data = JSON.parse(json.textContent);
    var idInput = $('input[name="id"]', form);
    var btn = $('[data-add]', form);
    var price = $('[data-product-price]');
    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option]')) return;
      var chosen = $$('.option', form).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
      if (e.target.closest('[data-color-option]')) filterGallery(e.target.value);
      var nm = e.target.closest('[data-color-option]') && e.target.closest('[data-color-option]').querySelector('[data-color-name]');
      if (nm) nm.textContent = e.target.value;
      var v = data.variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
      if (!v) { btn.disabled = true; btn.textContent = btn.dataset.unavailable; return; }
      idInput.value = v.id;
      if (price) price.innerHTML = v.price_html;
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.dataset.addLabel : btn.dataset.soldout;
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    });
  });
})();

/* ---------- Spotted in OFFGRID: filters + full-screen photo viewer ---------- */
(function () {
  var grid = document.querySelector('[data-spotted]');
  if (!grid) return;
  var all = Array.prototype.slice.call(grid.querySelectorAll('.spotted__item'));
  var count = document.querySelector('[data-spotted-count]');
  function visible() { return all.filter(function (f) { return !f.hidden; }).map(function (f) { return f.querySelector('.spotted__open'); }); }

  // Filter chips: All / Hoodies / Tees / Sets / Details
  var chips = Array.prototype.slice.call(document.querySelectorAll('[data-spotted-filter]'));
  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      var g = c.dataset.spottedFilter;
      chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c); });
      all.forEach(function (f) { f.hidden = !!g && f.dataset.group !== g; });
      if (count) count.textContent = visible().length;
      layout(true);
    });
  });
  // Masonry, filled left-to-right: each photo goes into the currently shortest column,
  // so photo order reads across rows (newest first) instead of down one column.
  var lastCols = 0;
  function colsFor() { var w = grid.clientWidth || window.innerWidth; return window.innerWidth > 1000 ? 3 : (window.innerWidth > 600 ? 2 : 1); }
  function ratio(f) { var im = f.querySelector('img'); var w = +im.getAttribute('width'), h = +im.getAttribute('height'); return (w && h) ? h / w : 1.25; }
  function layout(force) {
    var n = colsFor();
    if (!force && n === lastCols) return;
    lastCols = n;
    var cols = [], heights = [];
    for (var k = 0; k < n; k++) { var c = document.createElement('div'); c.className = 'spotted__col'; cols.push(c); heights.push(0); }
    all.forEach(function (f) {
      if (f.hidden) { cols[0].appendChild(f); return; }
      var t = 0; for (var k = 1; k < n; k++) if (heights[k] < heights[t] - 0.02) t = k;
      cols[t].appendChild(f); heights[t] += ratio(f) + 0.12;
    });
    grid.textContent = '';
    cols.forEach(function (c) { grid.appendChild(c); });
    grid.classList.add('is-masonry');
  }
  layout(true);
  window.addEventListener('resize', function () { layout(false); });

  // Hide chips for groups that have no photos
  chips.forEach(function (c) { var g = c.dataset.spottedFilter; if (g && !all.some(function (f) { return f.dataset.group === g; })) c.hidden = true; });

  var box = document.querySelector('[data-lightbox]');
  if (!box || typeof box.showModal !== 'function') return;
  var img = box.querySelector('[data-lightbox-img]'), cap = box.querySelector('[data-lightbox-cap]');
  var list = [], i = 0, opener = null;
  function show(k) {
    i = (k + list.length) % list.length;
    var b = list[i];
    img.src = b.dataset.full;
    img.alt = (b.querySelector('img') || {}).alt || '';
    cap.textContent = (b.dataset.caption || '') + '  ·  ' + (i + 1) + ' / ' + list.length;
  }
  grid.addEventListener('click', function (e) {
    var b = e.target.closest('.spotted__open'); if (!b) return;
    list = visible(); opener = b; show(list.indexOf(b));
    box.querySelectorAll('.lightbox__nav').forEach(function (n) { n.hidden = list.length < 2; });
    box.showModal(); document.body.style.overflow = 'hidden';
  });
  box.addEventListener('close', function () { document.body.style.overflow = ''; img.removeAttribute('src'); if (opener) opener.focus(); });
  box.querySelector('[data-lightbox-close]').addEventListener('click', function () { box.close(); });
  box.querySelector('[data-lightbox-prev]').addEventListener('click', function () { show(i - 1); });
  box.querySelector('[data-lightbox-next]').addEventListener('click', function () { show(i + 1); });
  box.addEventListener('click', function (e) { if (e.target === box) box.close(); });
  box.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') show(i - 1); if (e.key === 'ArrowRight') show(i + 1); });
  var x0 = null;
  box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
  box.addEventListener('touchend', function (e) {
    if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
    if (Math.abs(dx) > 50) show(dx < 0 ? i + 1 : i - 1);
  }, { passive: true });
})();

/* ---------- Contact page: message counter + focus confirmation ---------- */
(function () {
  document.querySelectorAll('[data-count-target]').forEach(function (t) {
    var out = document.getElementById(t.dataset.countTarget);
    var max = t.getAttribute('maxlength');
    function upd() { if (out) out.textContent = t.value.length + ' / ' + max; }
    t.addEventListener('input', upd); upd();
  });
  var sent = document.querySelector('[data-contact-sent]');
  if (sent) { sent.scrollIntoView({ block: 'center' }); sent.focus({ preventScroll: true }); }
})();
